import React from 'react';
import { FaExclamationCircle, FaCheckCircle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import './FeedbackModal.css';

const FeedbackModal = ({ isOpen, onClose, title, message, type = 'error' }) => {
    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'success': return <FaCheckCircle className="feedback-icon success" />;
            case 'info': return <FaInfoCircle className="feedback-icon info" />;
            default: return <FaExclamationCircle className="feedback-icon error" />;
        }
    };

    return (
        <div className="feedback-modal-overlay" onClick={onClose}>
            <div className={`feedback-modal-content ${type}`} onClick={e => e.stopPropagation()}>
                <div className="feedback-modal-header">
                    {getIcon()}
                    <h3>{title || (type === 'error' ? 'Error' : 'Aviso')}</h3>
                    <button className="feedback-close-x" onClick={onClose}><FaTimes /></button>
                </div>
                <div className="feedback-modal-body">
                    <p>{message || 'Operación completada.'}</p>
                </div>
                <div className="feedback-modal-footer">
                    <button className={`feedback-action-btn ${type}`} onClick={onClose}>
                        Entendido
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
